(ns storrito.editor.fit-object
  (:require [storrito.image :as image]
            [storrito.instagram.story.editor.dimension :as dimension]))

;; Concept:
;;
;; Provides tools to fit a FabricJS object into the story size, so
;; that very large pictures are still easy to handle in the story
;; editor.

(defn fit-object
  "Returns the properties to scale and position the object, so that it fits into
   the size of the canvas."
  ([object-data canvas-size]
   (let [scaled-size (image/fill (select-keys object-data
                                              [:width
                                               :height])
                                 canvas-size)]
     {:scaleX (:scale-factor scaled-size)
      :scaleY (:scale-factor scaled-size)
      :top (- (/ (:height canvas-size) 2.0)
              (/ (:height scaled-size) 2.0))}))
  ([object-data]
   (fit-object object-data
               dimension/story-image)))
